<div class="card-block">
    <!-- Form Search type person fisica-->
    <div class="row">
        <div class="col-xs-12 col-md-4">
            <div class="form-group">
                <label>Número de Caso</label>
                <input type="number" class="form-control" name="CasoId" [(ngModel)]="alertaService.caso.CasoId" readonly
                    placeholder="Número de Caso">
            </div>
        </div>
        <div class="col-xs-12 col-md-4">
            <div class="form-group">
                <label>Número de Persona</label>
                <input type="text" class="form-control" name="ClaveCia" [(ngModel)]="alertaService.caso.ClaveCia"
                    readonly>
            </div>
        </div>
        <div class="col-xs-12 col-md-4">
            <div class="form-group">
                <label>Nombre Completo</label>
                <input type="text" class="form-control" name="Nombre" [(ngModel)]="alertaService.caso.Nombre" readonly>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 col-md-4">
            <div class="form-group">
                <label>Fecha de Registro</label>
                <div class="input-group date input-group-date-custom">
                    <input type="date" class="form-control" name="FechaRegistro"
                        [(ngModel)]="alertaService.caso.FechaRegistro" readonly>
                    <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-4">
            <div class="form-group">
                <label>Tipo de Alerta</label>
                <select class="form-control" name="PersonaId" [(ngModel)]="alertaService.caso.AlertaId" required
                    #AlertaId="ngModel" [ngClass]="{ 'is-invalid':  AlertaId.errors?.required,
                'is-valid':  !AlertaId.errors?.required}">
                    <option value="">Selecciona Tipo de Alerta</option>
                    <option *ngFor="let item of alertas" [value]="item.alertaId">{{ item.alerta }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="AlertaId.errors?.required">
                    Debes llenar este campo
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-4">
            <div class="form-group">
                <label>Monto del caso</label>
                <div class="input-group date input-group-date-custom">
                    <span class="input-group-addon"><i class="fa fa-money"></i></span>
                    <input type="input" class="form-control" name="Monto" value="{{ getMonto() | currency:'MXN':true }}"
                        required>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!esRelevante()">
        <div class="col-md-12">
            <div class="form-group">
                <label>Descripción de la operación</label>
                <textarea rows="3" type="text" class="form-control" name="Comentarios" required #Comentarios="ngModel"
                    [(ngModel)]="alertaService.caso.Comentarios" [ngClass]="{ 'is-invalid':  Comentarios.errors?.required,
                    'is-valid':  !Comentarios.errors?.required}"></textarea>
                <div class="invalid-feedback" *ngIf="Comentarios.errors?.required">
                    Debes llenar este campo
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!esRelevante()">
        <div class="col-md-12">
            <div class="form-group">
                <label>Razones</label>
                <textarea rows="3" type="text" class="form-control" name="MotivoReporte" required
                    #MotivoReporte="ngModel" [(ngModel)]="alertaService.caso.MotivoReporte" [ngClass]="{ 'is-invalid':  MotivoReporte.errors?.required,
                    'is-valid':  !MotivoReporte.errors?.required}"></textarea>
                <div class="invalid-feedback" *ngIf="MotivoReporte.errors?.required">
                    Debes llenar este campo
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="esRelevante()">
        <div class="col-md-12">
            <div class="form-group">
                <label>Descripción de la operación</label>
                <textarea rows="3" type="text" class="form-control" name="Comentarios" disabled
                    [(ngModel)]="alertaService.caso.Comentarios"></textarea>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="esRelevante()">
        <div class="col-md-12">
            <div class="form-group">
                <label>Razones</label>
                <textarea rows="3" type="text" class="form-control" name="MotivoReporte" disabled
                    [(ngModel)]="alertaService.caso.MotivoReporte"></textarea>
            </div>
        </div>
    </div>
</div>